import base from "./base.service";

const instance = base.service();

export const getAll = () => {
    return instance.get("/galerija/all"); 
};

export const getSlikeGalerija = (id) =>
{
    return instance.get(`/galerija/${id}`);
}

export const deleteSlikaGalerija = (id) =>
{
    return instance.delete(`/galerija/${id}`);
}


export const uploadSlikaGalerija = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return instance.post("/galerija/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};


export default {
    getAll, getSlikeGalerija,deleteSlikaGalerija,uploadSlikaGalerija
};